import { apiProvider } from "@/services/utilities/Provider";

export const POLL_INTERVAL_MS = 2000;

const run = (incidents) => apiProvider.post('admin/scenariotester/run', incidents);
const getStatus = (jobId) => apiProvider.get(`admin/scenariotester/status/${jobId}`);

export default { run, getStatus };
